import { render, staticRenderFns } from "./ElementMultiInstanceAssignee.vue?vue&type=template&id=d70b2a1c&scoped=true&"
import script from "./ElementMultiInstanceAssignee.vue?vue&type=script&lang=js&"
export * from "./ElementMultiInstanceAssignee.vue?vue&type=script&lang=js&"
import style0 from "./ElementMultiInstanceAssignee.vue?vue&type=style&index=0&id=d70b2a1c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d70b2a1c",
  null
  
)

export default component.exports